import { show } from '@intercom/messenger-js-sdk'

import { toggleIntercom } from '../store/slice/ui-slice'
import { TSidebarMenu } from '../types/global.types'

import { useAppDispatch } from './use-app-dispatch'

export const useSidebarMenu = () => {
  const dispatch = useAppDispatch()

  const handleToggleIntercom = () => {
    dispatch(toggleIntercom(true))
    return show()
  }

  const sidebarMenu: Readonly<TSidebarMenu[]> = [
    {
      pathname: '/home',
      title: 'Survey List',
      showForGuest: true,
      openInNewTab: false,
      hideOnDeletionAccount: false,
      hideOnSuspend: false,
      hideOnDeletedAccountPir: false,
    },
    {
      pathname: '/profile',
      title: 'Profile',
      showForGuest: true,
      openInNewTab: false,
      hideOnDeletionAccount: true,
      hideOnSuspend: true,
      hideOnDeletedAccountPir: true,
    },
    {
      pathname: '/survey-history',
      title: 'Submission History',
      showForGuest: true,
      openInNewTab: false,
      hideOnDeletionAccount: true,
      hideOnSuspend: true,
      hideOnDeletedAccountPir: true,
    },
    {
      pathname: '/notification-settings',
      title: 'Notification Settings',
      showForGuest: true,
      openInNewTab: false,
      hideOnDeletionAccount: true,
      hideOnSuspend: true,
      hideOnDeletedAccountPir: true,
    },
    {
      pathname: '/rewards',
      title: 'Rewards',
      showForGuest: true,
      openInNewTab: false,
      hideOnDeletionAccount: true,
      hideOnSuspend: true,
      hideOnDeletedAccountPir: true,
    },
    {
      pathname: '/articles/terms-and-condition',
      title: 'Terms and Condition',
      showForGuest: true,
      openInNewTab: false,
      isAuthPartner: true,
      hideOnDeletionAccount: false,
      hideOnSuspend: false,
      hideOnDeletedAccountPir: false,
    },
    {
      pathname: '/articles/privacy-policy',
      title: 'Privacy Policy',
      showForGuest: true,
      isAuthPartner: true,
      openInNewTab: false,
      hideOnDeletionAccount: false,
      hideOnSuspend: false,
      hideOnDeletedAccountPir: false,
    },
    {
      onClick: handleToggleIntercom,
      title: 'Help Center',
      showForGuest: true,
      openInNewTab: true,
      isAuthPartner: true,
      hideOnDeletionAccount: false,
      hideOnSuspend: false,
      hideOnDeletedAccountPir: false,
    },
  ]

  return {
    sidebarMenu,
  }
}
